import { SiteUrls } from '@tableau/shared-urls';
import { DialogPositioningBehavior, DialogType } from '@tableau/widgets';
import React from 'react';

import { Messages } from '../../codegen/Localize';
import { FilteringListBox } from '../../common/react/components/FilteringListBox';
import { SparseCachedList } from '../../common/react/SparseCachedList';
import { ReactModalService } from '../../commonInfra/dialogs/ReactModalService';
import {
  getSessionManagementServiceInstance,
  SessionManagementService,
} from '../../sessionManagement/SessionManagementService';
import { IUser } from '../../ts/ServerApi/types/IUser';
import { IDataAlertInfo } from '../models/IDataAlertInfo';
import { DataAlertUsers } from '../resources/DataAlertUsers';
import { ManageDataAlertRecipientsDialogStyles } from '../styles/ManageDataAlertRecipientsDialogStyles';
import { ManageDataAlertRecipientsDialogBody } from './ManageDataAlertRecipientsDialogBody';

export class ManageDataAlertRecipientsDialog {

  public static readonly instance = new ManageDataAlertRecipientsDialog();

  // Search string filter for filtering recipients in the list box
  private filter: string;

  // Cached list of items fetched from the user query provided to the component
  private itemCache: SparseCachedList<FilteringListBox.Item<IUser>, IUser>;

  // Item store for the FilteredListBox component (fetches items from the item cache)
  private itemStore = { getItems: this.getItems.bind(this) };

  private  dataAlert: IDataAlertInfo;

  private sessionManagementService: SessionManagementService;

  public open(alert: IDataAlertInfo) {
    this.dataAlert = alert;
    this.createCacheWithFilter('');

    const props:  FilteringListBox.Props<IUser> = {
      searchBoxPlaceholder: Messages.searchRecipients(),
      matchPrefixesOnly: false,
      itemStore: this.itemStore,
      style: ManageDataAlertRecipientsDialogStyles.STYLE,
      listBoxStyle: ManageDataAlertRecipientsDialogStyles.LIST_BOX_STYLE,
    };

    const modal = ReactModalService.open({
        title: Messages.alertRecipients(),
        type: DialogType.NormalWithTitleBar,
        positioningBehavior: DialogPositioningBehavior.Centered,
        dialogContent: <ManageDataAlertRecipientsDialogBody {...props}/>,
        dialogContentStyle: {},
        showCloseButton: true,
        dialogWidth: 460
    });
    return modal;
  }

  private getItems(filter: string, start: number, end: number, rowHandler: (rowsPromise: Promise<FilteringListBox.Item<IUser>[]>) => void): void {
    if (filter !== this.filter) {
      this.createCacheWithFilter(filter);
    }

    this.itemCache.getItemsAsync(start, end, rowHandler);
  }

  private createCacheWithFilter(filter: string) {
    if(!this.sessionManagementService){
      this.sessionManagementService = getSessionManagementServiceInstance();
    }

    const query = DataAlertUsers.getUsersQuery(this.dataAlert.id, filter);
    this.filter = filter;
    this.itemCache = new SparseCachedList<FilteringListBox.Item<IUser>, IUser>(query, (user: IUser) => {
      const siteUrls = new SiteUrls({siteUrlName: this.sessionManagementService.sessionSiteUrlName(), queryString: window.location.search});
      return {
        label: user.displayName,
        url: siteUrls.userUrl(user.username, user.domainName),
        rawItem: user,
      };
    });
  }
}
